import React from 'react';

export default function Hello() {
  return (
    <div className="h-[50vh] flex flex-col justify-center items-center">
      <h1 className="text-4xl font-bold">You are logged in</h1>
    </div>
  );
}